import { render, staticRenderFns } from "./SingleDetail.vue?vue&type=template&id=42b32b47&scoped=true&"
import script from "./SingleDetail.vue?vue&type=script&lang=js&"
export * from "./SingleDetail.vue?vue&type=script&lang=js&"
import style0 from "./SingleDetail.vue?vue&type=style&index=0&id=42b32b47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b32b47",
  null
  
)

export default component.exports